<div class="main-container" [width]="'100%'" [height]="'100%'">
  <wiz-hgroup class="fixed-tab-container" [width]="'100%'">
    <div  #tabContainer width="100%"  class="fixed-tab-container" [height]="'100%'">
      <div
        #divButtonContainer
        id="tabs-container"
        class="tab-container"
        wizDragDrop
        [wizDragEnabled]="dragEnabled"
        [wizDropEnabled]="dropEnabled"
        [wizDragMove]="false"
        [wizEnableSelfReorder]="true"
        [wizShowDropIndicator]="dropEnabled"
      >
        <div
          *ngFor="let actObj of wizButtonList"
          (mousedown)="onTabMouseDown($event, actObj)"
        >
          <wiz-tab-button
            [actionObj]="actObj"
            [selected]="isSelected(actObj)"
          ></wiz-tab-button>
        </div>
      </div>
    </div>
    <div #divAddContainer *ngIf="showNavigation" class="tool-container">
      
    </div>
  </wiz-hgroup>
  <div #navContainer *ngIf="showNavigation" class="tool-container" [height]="'100%'">
    <wiz-hgroup verticalAlign="center" width="160px" horizontalAlign="end" gap="5" style="padding-right: 10px; padding-left: 10px;">
      <wiz-icon (click)="doNav('add')" class="image-back-orange smallMe" [wizTooltip]="'$.common.managetabs.$'" tooltipPlacement="right">add</wiz-icon>
      <wiz-icon (click)="doNav('first')" [wizDisabled]="isScrollBackDisabled" class="image-purple smallMe" >double-arrow-left</wiz-icon>
      <wiz-icon (click)="doNav('previous')" [wizDisabled]="isScrollBackDisabled" class="image-purple smallMe" >arrow-left</wiz-icon>
      <wiz-icon (click)="doNav('next')" [wizDisabled]="isScrollForwardDisabled" class="image-purple smallMe" >arrow-right</wiz-icon>
      <wiz-icon (click)="doNav('last')" [wizDisabled]="isScrollForwardDisabled" class="image-purple smallMe" >double-arrow-right</wiz-icon>
    </wiz-hgroup>
  </div>
</div>
